import CustomHelmet from "../../components/helmet/CustomHelmet.tsx";
import LegalBanner from "../../components/privacy-policy-page-components/legal-banner/LegalBanner.tsx";
import bannerImage from "/assets/images/why-opay-page-images/icon-about-feature-7.svg";
import LegalPageSections
    from "../../components/privacy-policy-page-components/privacy-policy-sections/LegalPageSections.tsx";
import {ProhibitedActivitiesSectionsConfig} from "../../configs/legal-pages/prohibitedActivitiesSections.ts";

const ProhibitedActivitiesPage = () => {
    return (
        <>
            <CustomHelmet title={'titles.prohibited_activities'} />
            <LegalBanner heading={'prohibited_activities'} image={bannerImage} />
            <LegalPageSections config={ProhibitedActivitiesSectionsConfig} />
        </>
    )
}

export default ProhibitedActivitiesPage;
